// extracted by mini-css-extract-plugin
module.exports = {"uploadWrapper":"oam-course_uploadWrapper__3BBWR"};